module.exports = __webpack_public_path__ + "img/icon_29.f47504be.png";